module.exports = "https://static.wmbcdn.com/uniweb/images/d82c545a1dfe15675fc8b393c0659fe8.svg";